import React from 'react';
import GoogleCommand from './command/GoogleCommand';
import YouTubeCommand from './command/YouTubeCommand';
import BingCommand from './command/BingCommand';
import AmazonCommand from './command/AmazonCommand';
import XCommand from './command/XCommand';

const COMMAND_COMPONENTS = {
    google: GoogleCommand,
    youtube: YouTubeCommand,
    bing: BingCommand,
    amazon: AmazonCommand,
    x: XCommand,
};

function CommandSelector({ selectedSite, value, commands, onChange, onCommandChange, onAddCommand }) {
    // 選択されたサイトに対応するコンポーネントを取得
    const SpecificCommand = COMMAND_COMPONENTS[selectedSite];

    return (
        <div>
            {SpecificCommand && (
                <SpecificCommand
                    value={value}
                    commands={commands}
                    onChange={onChange}
                    onCommandChange={onCommandChange}
                    onAddCommand={onAddCommand}
                />
            )}
        </div>
    );
}



export default CommandSelector;

